import { SET_SALT_MODE } from './types';

export default (state = [], action) => {
  switch (action.type) {
    case SET_SALT_MODE:
      return action.mode;
    default:
      return state;
  }
};
